// Re-export TRPC client from the new structure
export { trpc } from '@/trpc/react';
